<template>
  <div v-if="bannerPlaceHolderForNewExclusiveRevamp"
  class="row exc-cat-card-inner-new"
  @click="categoryDetails(value, value.gender)">
    <div class="pl-2 pt-2 pb-2 pr-0" :class="isDesktop ? 'col-6' : ''">
      <img class="Group-11" :src="value.image" alt="Image">
    </div>
    <div :class="isDesktop ? 'col-6' : 'col-7'" :style="isDesktop ? 'padding: 0;' : ''">
       <p class="exc-category-name-new text-left pl-1" :class="isDesktop ? 'pt-4' : 'pt-3'">{{value.product_name}}</p>
       <p class="exc-text-cat-new pl-1">{{value.category}}</p>
       <div class="col-12 p-0" style="background: #e8e8e8;position: absolute;" :style="isDesktop ? 'top: 46%;left: -0.86%;': 'top: 45%;left: -0.1%;'">
          <div class="col-6 p-0 Regular-Price">
            <p>Regular Price</p>
          </div>
          <div class="col-6 p-0 Exclusive-Price">
            <p>Exclusive Price</p>
          </div>
       </div>
       <div class="col-12 p-0" style="position: absolute;left: -0.1%;" :style="isDesktop ? 'bottom: 15%;' : 'bottom: 17%;'">
          <div class="col-6 p-0" style="border-right: 1px solid #e8e8e8;">
            <p class="exc-regular-value" style="color: #122643;font-size: 1.313rem;">₹{{parseInt(value.regular_price)}}</p>
          </div>
          <div class="col-6 p-0">
            <p class="exc-price-value" style="font-size: 1.313rem;">₹{{value.exclusive_price}}</p>
            <p v-if="value.regular_price > 0" style="font-size: 0.625rem;font-style: italic;color: #148c8d;ont-weight: normal;font-stretch: normal;">Save {{parseInt(((value.regular_price - value.exclusive_price)/value.regular_price)*100)}}%</p>
            <p v-else style="font-size: 0.625rem;font-style: italic;color: #148c8d;ont-weight: normal;font-stretch: normal;">Save 0%</p>
          </div>
       </div>
    </div>
  </div>
  <div v-else class="exc-cat-card-inner" @click="categoryDetails(value, value.gender)">
    <img class="exc-cat-card-img" :src="value.image" alt="Image">
    <p class="exc-category-name">{{value.product_name}}</p>
    <p class="exc-regular-title">REGULAR PRICE</p>
    <p class="exc-regular-value">₹ {{value.regular_price}}</p>
    <p class="exc-price">EXCLUSIVE PRICE</p>
    <p class="exc-price-value">₹ {{value.exclusive_price}}</p>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  data () {
    return {
      baseImgPath: process.env.IMG_BASE_URL,
      imgSize: 'cdn-cgi/image/width=300,height=400,quality=100/',
      imgPath: process.env.PRODUCT_IMG
    }
  },
  methods: {
    categoryDetails (detailPageUrl, gender) {
      let gte = gender ? '?gte=2' : '?gte=1'
      this.$router.push(`/product/${detailPageUrl.category}${gte}`)
    }
  },
  props: ['value', 'isDesktop'],
  computed: {
    ...mapGetters(['bannerPlcaeHolderData']),
    bannerPlaceHolderForNewExclusiveRevamp: function () {
      const isExclusiveRevampObj = this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'EXCLUSIVE_REVAMP_NEW'.toLowerCase())
      if (isExclusiveRevampObj) {
        return true
      }
      return null
    }
  }
}

</script>

<style scoped>

.exc-cat-card-inner {
  border: solid 2px #a9aaa9;
  border-radius: 5px;
  background-color: #fff;
  padding: 11px;
  max-width: 215px;
  height: auto;
  margin: 0 30px;
  height: 410px;
  cursor: pointer;
}
.exc-cat-card-inner-new {
  object-fit: contain;
  border-radius: 5px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #e8e8e8;
  background-color: #f9f9f9;
  min-width: 316px;
  max-width: 315px;
  min-height: 210px;
  max-height: 210px;
}
.exc-cat-card-img {
  max-width: 100%;
  border-radius: 5px;
  margin-top: -50px;
}
.exc-category-name {
  padding-top: 10px; 
  color: #e66a51;
  font-size: 14px;
  font-weight: bold;
  min-height: 20%;
  justify-content: center;
  align-items: center;
  display: flex;
}
.exc-category-name-new{
  font-family: 'Source Sans Pro semibold', sans-serif !important;
  font-size: 1rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: left;
  color: #122643;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.exc-text-cat-new {
  font-size: 0.813rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: italic;
  line-height: 1.23;
  letter-spacing: normal;
  text-align: left;
  color: #979a9f;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.Regular-Price {
  font-size: 0.713rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.55;
  letter-spacing: normal;
  text-align: center;
  color: #122643;
  font-family: OpenSans-SemiBold !important;
}
.Exclusive-Price {
  font-size: 0.713rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.54;
  letter-spacing: normal;
  text-align: left;
  color: #e76a52;
  font-family: OpenSans-SemiBold !important;
}
.exc-regular-title {
  color: #646769;
  font-weight: 600;
  font-size: 18px;
}
.exc-regular-value {
  color: #646769;
  font-weight: 600;
  font-size: 16px;
}
.exc-price {
  color: #e66a51;
  font-weight: 600;
  font-size: 18px;
}
.exc-price-value {
  color: #e66a51;
  font-weight: bold;
  font-size: 28px;
  line-height: 30px;
}
p {
  padding: 0;
  margin: 0;
}
.Group-11 {
  max-width: 9.06rem;
  min-height: 11.9rem;
  object-fit: cover;
  border-radius: 0.9rem;
}
@media screen and (max-width: 1024px) {
  .exc-cat-card-inner {
    max-width: 210px;
    margin: 0 20px;
    width: 195px;
    height: 380px;
  }
}
@media screen and (max-width: 991px) {
  .exc-cat-card-inner {
    max-width: 220px;
    margin: 0 10px;
    width: 180px;
    height: 350px;
  }
}

@media screen and (max-width: 767px) {
  .exc-category-name {
    font-size: 14px;
  }
  .exc-regular-title {
    font-weight: 600;
    font-size: 16px;
  }
  .exc-regular-value {
    font-size: 14px;
  }
  .exc-price {
    font-size: 16px;
  }
  .exc-price-value {
    font-size: 25px;
    line-height: 25px;
  }
  .exc-cat-card-inner {
    margin: 0 15px;
  }

  .exc-cat-card-img {
    width: 95%;
  }

  @media screen and (max-width: 576px) {
    .exc-cat-card-inner {
      height: 320px;
    }
  }
  @media screen and (max-width: 480px) {
    .exc-cat-card-inner-new {
      min-width: 261px;
      max-width: 261px;
      min-height: 150px;
      max-height: 150px;
    }
    .Group-11 {
      max-width: 99px;
      min-height: 7.538rem;
      object-fit: cover;
      border-radius: 0.9rem;
    }
    .exc-category-name-new {
      font-size: 0.7rem;
    }
    .exc-text-cat-new {
      font-size: 0.7rem;
      -webkit-font-smoothing: antialiased;
    }
    .Regular-Price {
      font-size: 0.56rem;
      padding: 0 !important;
      font-weight: normal !important;
      letter-spacing: 0px;
      font-family: -apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif !important;
    }
    .Exclusive-Price {
      font-size: 0.6rem;
      padding: 0 !important;
      font-weight: normal !important;
      letter-spacing: 0px;
      font-family: -apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif !important;
    }
    .exc-regular-value {
      font-size: 1.1rem !important;
    }
    .exc-price-value {
      font-size: 1.1rem !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// excCategoryCard.vue?d75b1b6a